import BreadcrumbContainer from "../../../Components/BonusUi/Breadcrumb/BreadcrumbContainer";

const Breadcrumb = () => {
  return <BreadcrumbContainer />;
};

export default Breadcrumb;
